(function () {
  // Prevent the whole script from running twice if it gets included twice
  if (window.__krugerPricesScriptLoaded) return;
  window.__krugerPricesScriptLoaded = true;

  const CSV_URL =
    "https://docs.google.com/spreadsheets/d/1qsQDEQdhHynLG8HL8tiYzQ1IhvxQ2hZjehavgTPU150/export?format=csv&gid=1525751479";

  // Find all instances (repeatable blocks)
  const containers = Array.from(document.querySelectorAll(".kruger-prices"));
  if (!containers.length) return;

  containers.forEach((el) => {
    el.innerHTML = `<div class="kruger-loading">Loading live prices…</div>`;
  });

  // Fetch ONCE, render everywhere
  fetch(CSV_URL, { cache: "no-store" })
    .then((res) => {
      if (!res.ok) throw new Error("Failed to load pricing data");
      return res.text();
    })
    .then((csv) => {
      const rows = parseCSV(csv)
  .map(r => r.map(c => String(c ?? "").trim()))
  .filter(r => r.some(c => c !== "")); // remove empty rows

// Helpers
const findRowIndexContains = (needle) =>
  rows.findIndex(r => r.some(c => c.toUpperCase().includes(needle.toUpperCase())));

const getFirstCellContains = (needle) => {
  const idx = findRowIndexContains(needle);
  if (idx === -1) return null;
  return rows[idx].find(c => c.toUpperCase().includes(needle.toUpperCase())) || rows[idx][0] || null;
};

// Find header/meta rows (based on your CSV structure)
const titleRowIdx = findRowIndexContains("KRUGERRAND INDICATION PRICES");
const dateRowIdx  = rows.findIndex(r => r.some(c => /(MONDAY|TUESDAY|WEDNESDAY|THURSDAY|FRIDAY|SATURDAY|SUNDAY)/i.test(c)));
const timeRowIdx  = rows.findIndex(r => r.some(c => /\b\d{1,2}:\d{2}\b/i.test(c) && /(AM|PM)/i.test(c)));

const titleText = titleRowIdx !== -1 ? rows[titleRowIdx].find(c => c) : "KRUGERRAND INDICATION PRICES";
const dateText  = dateRowIdx !== -1  ? rows[dateRowIdx].find(c => /(MONDAY|TUESDAY|WEDNESDAY|THURSDAY|FRIDAY|SATURDAY|SUNDAY)/i.test(c)) : "";
const timeText  = (timeRowIdx !== -1  ? rows[timeRowIdx].find(c => /\b\d{1,2}:\d{2}\b/i.test(c)) : "").replace(/(\d{1,2}:\d{2}):\s*/, "$1 ");

// GOLD / USD / Rands line
const goldRowIdx = findRowIndexContains("GOLD $");
let goldText = "", usdText = "", zarText = "";

if (goldRowIdx !== -1) {
  const r = rows[goldRowIdx];
  // Expected pattern: ["GOLD $", "4902", "US$1=R", "16.14", "R 79,118"] but may have blanks
  const goldLabelIdx = r.findIndex(c => c.toUpperCase().includes("GOLD $"));
  const usdLabelIdx  = r.findIndex(c => c.toUpperCase().includes("US$1=R") || c.toUpperCase().includes("US$1=R"));

  const goldValue = goldLabelIdx !== -1 ? (r[goldLabelIdx + 1] || "") : "";
  const usdLabel  = usdLabelIdx !== -1  ? r[usdLabelIdx] : "US$1=R";
  const usdValue  = usdLabelIdx !== -1  ? (r[usdLabelIdx + 1] || "") : "";
  const randsVal  = r.find(c => /^R\s?[\d,]+/i.test(c)) || r[r.length - 1] || "";

  goldText = `GOLD $ ${goldValue}`.trim();
  usdText  = `${usdLabel} ${usdValue}`.trim();
  zarText  = randsVal.trim();
}

// Find the table header row ("KRUGERRANDS")
const headerIndex = rows.findIndex(r => r.some(c => c.toUpperCase() === "KRUGERRANDS"));
if (headerIndex === -1) throw new Error('Could not find "KRUGERRANDS" header row in the CSV.');

// Table headers
const headers = ["Krugerrands", "We buy at", "We sell at"];

// Data rows (product in col 2, buy col 4, sell col 6 in your CSV)
const data = rows
  .slice(headerIndex + 1)
  .filter(r => r[1] && (r[3] || r[5]))
  .map(r => [r[1], r[3] || "", r[5] || ""]);

// OPTIONAL: disclaimer (if present)
const disclaimerRowIdx = findRowIndexContains("Prices may vary");
const disclaimerText = disclaimerRowIdx !== -1 ? rows[disclaimerRowIdx].join(" ").trim() : "";

// Render wrapper + header
containers.forEach((el) => {
  if (el.dataset.krugerRendered === "1") return;
  el.dataset.krugerRendered = "1";

  el.innerHTML = `
    <div class="kruger-header">
      ${dateText ? `<div class="kruger-header__date">${escapeHtml(dateText)}</div>` : ``}
      ${timeText ? `<div class="kruger-header__time">${escapeHtml(timeText)}</div>` : ``}
      <div class="kruger-header__title">${escapeHtml(titleText || "KRUGERRAND INDICATION PRICES")}</div>

      ${(goldText || usdText || zarText) ? `
        <div class="kruger-header__stats">
          <div class="kruger-header__stat">${escapeHtml(goldText)}</div>
          <div class="kruger-header__stat">${escapeHtml(usdText)}</div>
          <div class="kruger-header__stat">${escapeHtml(zarText)}</div>
        </div>
      ` : ``}
    </div>

    <div class="kruger-prices-wrap">
      <div class="kruger-table"></div>
      <div class="kruger-cards"></div>
    </div>

    ${disclaimerText ? `<div class="kruger-disclaimer">${escapeHtml(disclaimerText)}</div>` : ``}
  `;

  renderTable(el.querySelector(".kruger-table"), headers, data);
  renderCards(el.querySelector(".kruger-cards"), headers, data);
});

      containers.forEach((el) => {
        // Prevent re-rendering if something calls this again
        if (el.dataset.krugerRendered === "1") return;
        el.dataset.krugerRendered = "1";

        el.innerHTML = `
          <div class="kruger-prices-wrap">
            <div class="kruger-table"></div>
            <div class="kruger-cards"></div>
          </div>
        `;

        renderTable(el.querySelector(".kruger-table"), headers, data);
        renderCards(el.querySelector(".kruger-cards"), headers, data);
      });
    })
    .catch((err) => {
      containers.forEach((el) => {
        el.innerHTML = `<div class="kruger-error">Couldn’t load prices right now. Please refresh.</div>`;
      });
      console.error(err);
    });

  function renderTable(target, headers, data) {
    if (!target) return;
    const th = headers.map((h) => `<th>${escapeHtml(h)}</th>`).join("");
    const trs = data
      .map((row) => `<tr>${row.map((c) => `<td>${escapeHtml(c ?? "")}</td>`).join("")}</tr>`)
      .join("");
    target.innerHTML = `
      <table class="kruger-table-ui">
        <thead><tr>${th}</tr></thead>
        <tbody>${trs}</tbody>
      </table>
    `;
  }

  function renderCards(target, headers, data) {
    if (!target) return;
    target.innerHTML = data
      .map((row) => {
        const pairs = headers
          .map(
            (h, i) => `
            <div class="kruger-pair">
              <div class="kruger-k">${escapeHtml(h)}</div>
              <div class="kruger-v">${escapeHtml(row[i] ?? "")}</div>
            </div>
          `
          )
          .join("");
        return `<div class="kruger-card">${pairs}</div>`;
      })
      .join("");
  }

  function escapeHtml(str) {
    return String(str).replace(/[&<>"']/g, (s) => ({
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#039;",
    }[s]));
  }

  // Minimal robust CSV parser (handles quotes + commas/newlines)
  function parseCSV(text) {
    const rows = [];
    let row = [];
    let cell = "";
    let inQuotes = false;

    for (let i = 0; i < text.length; i++) {
      const char = text[i];
      const next = text[i + 1];

      if (char === '"' && inQuotes && next === '"') { cell += '"'; i++; continue; }
      if (char === '"') { inQuotes = !inQuotes; continue; }

      if (char === "," && !inQuotes) { row.push(cell); cell = ""; continue; }

      if ((char === "\n" || char === "\r") && !inQuotes) {
        if (char === "\r" && next === "\n") i++;
        row.push(cell);
        rows.push(row);
        row = [];
        cell = "";
        continue;
      }

      cell += char;
    }

    row.push(cell);
    rows.push(row);
    return rows;
  }
})();